var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__a",
    width: 26,
    height: 26,
    x: 0,
    y: 0,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__b",
    width: 26,
    height: 24,
    x: 0,
    y: 0,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#BABFCD",
    opacity: 0.4,
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F4FA",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#949CAF",
    fillRule: "nonzero",
    d: "M13.084 17.14c.91 0 1.666-.238 2.268-.714.602-.49.952-1.106 1.022-1.876.154-1.414-.7-2.492-2.604-2.996l-1.232-.322c-.854-.224-1.288-.644-1.288-1.26 0-.784.756-1.33 1.666-1.33 1.008 0 1.68.574 1.68 1.456h1.484c0-.868-.294-1.554-.896-2.072-.588-.518-1.33-.784-2.24-.784-.868 0-1.61.266-2.24.784-.63.518-.938 1.176-.938 1.974 0 1.302.798 2.156 2.394 2.59l1.218.308c1.064.252 1.568.77 1.526 1.568-.112.742-.742 1.316-1.82 1.316-.546 0-1.008-.154-1.358-.476-.35-.322-.546-.7-.56-1.106H9.682c0 .798.322 1.498.966 2.072.644.574 1.456.868 2.436.868z",
    mask: "url(#prefix__c)",
    opacity: 0.6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.bb04b972.svg";
export { ForwardRef as ReactComponent };